import React from "react";

import { cn } from "../../lib/cn";
import SelectComponent from "./Select";

const MOBILE_BREAKPOINT = 768;

const ResponsiveSelect = ({
  options = [],
  value = null,
  onChange,
  placeholder = "Выберите...",
  isDisabled = false,
  className = "",
  label = "",
  id = "",
  required = false,
  mobileBreakpoint = MOBILE_BREAKPOINT,
  ...props
}) => {
  const selectId = React.useMemo(
    () => id || `responsive-select-${Math.random().toString(36).slice(2, 11)}`,
    [id],
  );
  const [isMobile, setIsMobile] = React.useState(
    () => window.innerWidth < mobileBreakpoint,
  );

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < mobileBreakpoint);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [mobileBreakpoint]);

  if (!isMobile) {
    return (
      <SelectComponent
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        isDisabled={isDisabled}
        className={className}
        label={label}
        id={selectId}
        required={required}
        {...props}
      />
    );
  }

  const currentValue = value?.value ?? "";

  return (
    <div className={cn("w-full mb-4", className)}>
      {label && (
        <label
          htmlFor={selectId}
          className="block text-sm font-semibold text-[var(--color-text-secondary)] mb-1.5"
        >
          {label}
          {required && (
            <span className="text-[var(--color-accent-danger)] ml-1">*</span>
          )}
        </label>
      )}
      <select
        id={selectId}
        value={currentValue}
        disabled={isDisabled}
        onChange={(event) => {
          const nextOption = options.find(
            (option) => String(option.value) === event.target.value,
          );
          onChange?.(nextOption || null);
        }}
        className="w-full bg-[var(--color-bg-tertiary)] border border-[var(--color-border)] text-[var(--color-text-primary)] px-4 py-2.5 rounded-xl focus:ring-2 focus:ring-[var(--color-primary)]/20 shadow-sm transition-all disabled:opacity-60"
      >
        {placeholder && currentValue === "" && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={String(option.value)} value={String(option.value)}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ResponsiveSelect;
